<div class="select-contact-component">

  <div class="row">
    <div class="col-lg-6 col-md-12">
      <mat-form-field>
        <mat-select [multiple]="false" [formControl]="formControlPredefinedSelection" placeholder="Select primary contact...">
          @for (predefinedContact of predefinedContactSelection; track predefinedContact) {
            <mat-option [value]="predefinedContact">
              {{predefinedContact.title?.name}} {{predefinedContact.firstName}} {{predefinedContact.lastName}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

</div>
